import React, { useEffect, useState } from "react";
import { api, statusPill, statusLabel } from "../lib/api";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export default function Alerts() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/alerts/passports").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="p-6 md:p-8 max-w-[1400px]" data-testid="alerts-page">
      <div className="flex items-center gap-3">
        <AlertTriangle className="text-[#8a5b00]" size={22} />
        <div>
          <div className="label-overline">Uyarılar</div>
          <h1 className="mt-1 font-display font-black text-3xl md:text-4xl tracking-tight">Pasaport Süresi Kısalanlar</h1>
        </div>
      </div>
      <p className="mt-3 text-sm text-zinc-500 max-w-2xl">Pasaportu 6 aydan az kalan veya süresi geçmiş müşteriler. Vize başvurusundan önce pasaport yenileme uyarısı yapın.</p>

      <div className="mt-8 grid-card overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead className="bg-zinc-50 text-left">
            <tr className="border-b border-zinc-200">
              <Th>Müşteri</Th><Th>Pasaport No</Th><Th>Bitiş Tarihi</Th><Th>Kalan Gün</Th><Th>Ülke</Th><Th>Durum</Th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className={`border-b border-zinc-100 hover:bg-zinc-50 ${c.expired ? "bg-red-50/40" : c.days_left < 60 ? "bg-amber-50/40" : ""}`} data-testid={`alert-row-${c.id}`}>
                <Td className="font-medium">{c.full_name}</Td>
                <Td>{c.passport_number || "—"}</Td>
                <Td>{c.passport_expiry_date}</Td>
                <Td>
                  {c.expired ? (
                    <span className="text-[#b71c1c] font-semibold">Süresi Geçmiş ({Math.abs(c.days_left)} gün)</span>
                  ) : (
                    <span className={c.days_left < 60 ? "text-[#b71c1c] font-semibold" : "text-[#8a5b00] font-semibold"}>{c.days_left} gün</span>
                  )}
                </Td>
                <Td>{c.country_name}</Td>
                <Td><span className={`status-pill ${statusPill(c.status)}`}>{statusLabel(c.status)}</span></Td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} className="p-10 text-center text-sm text-zinc-500">Uyarı yok — tüm pasaportlar 6 aydan uzun geçerli 🎉</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const Th = ({ children }) => <th className="px-4 py-3 label-overline font-medium">{children}</th>;
const Td = ({ children, className = "" }) => <td className={`px-4 py-3 ${className}`}>{children}</td>;
